import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

export const InspectionRedirect = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const {
    data: inspection,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["inspection-redirect", id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("inspections")
        .select("status")
        .eq("id", id!)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !!id,
  });

  useEffect(() => {
    if (isLoading) return;

    if (error || !inspection) {
      // Prüfung nicht gefunden - zur Liste zurück
      navigate("/inspections", { replace: true });
      return;
    }

    // Wenn Prüfung in Bearbeitung -> Execute, sonst Preview
    if (inspection.status === "in_progress") {
      navigate(`/inspections/${id}/execute`, { replace: true });
    } else {
      navigate(`/inspections/${id}/preview`, { replace: true });
    }
  }, [inspection, isLoading, error, id, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};
